// src/pages/Dashboard.jsx
import { useNavigate } from 'react-router-dom';
import DashboardLayout   from '../components/layout/DashboardLayout';
import StatCards         from '../components/dashboard/StatCards';
import WalletCard        from '../components/dashboard/WalletCard';
import ApplicationTracker from '../components/dashboard/ApplicationTracker';
import CVScoreRing       from '../components/dashboard/CVScoreRing';
import RecommendationFeed from '../components/dashboard/RecommendationFeed';
import NotificationsPanel from '../components/dashboard/NotificationsPanel';
import OnboardingProgress from '../components/dashboard/OnboardingProgress';

export default function Dashboard() {
  return (
    <DashboardLayout
      title="Dashboard"
      subtitle="Welcome back, Alex 👋 — 3 updates need your attention"
    >
      <style>{`
        .dash-row2 {
          display: grid;
          grid-template-columns: 300px 1fr;
          gap: 16px;
          margin-top: 16px;
          margin-bottom: 16px;
        }
        .dash-row3 {
          display: grid;
          grid-template-columns: 1fr 1fr 320px;
          gap: 16px;
        }
        @media (max-width: 1024px) {
          .dash-row3 { grid-template-columns: 1fr 1fr !important; }
          .dash-row3 > :last-child { grid-column: 1 / -1; }
        }
        @media (max-width: 768px) {
          .dash-row2 { grid-template-columns: 1fr !important; }
          .dash-row3 { grid-template-columns: 1fr !important; }
          .dash-row3 > :last-child { grid-column: auto; }
        }
      `}</style>

      <StatCards />

      <div className="dash-row2">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <OnboardingProgress />
          <CVScoreRing />
        </div>
        <ApplicationTracker />
      </div>

      <div className="dash-row3">
        <WalletCard />
        <RecommendationFeed />
        <NotificationsPanel />
      </div>
    </DashboardLayout>
  );
}
